module.exports = __webpack_public_path__ + "static/media/number-item-5.15aeb374.png";